/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventmembersofflink3Inputs */

const en_eventmembersofflink3 = /** @type {(inputs: Eventmembersofflink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to your organizer profile`)
};

const de_eventmembersofflink3 = /** @type {(inputs: Eventmembersofflink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Veranstalterprofil`)
};

/**
* | output |
* | --- |
* | "Go to your organizer profile" |
*
* @param {Eventmembersofflink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventmembersofflink3 = /** @type {((inputs?: Eventmembersofflink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventmembersofflink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventmembersofflink3(inputs)
	return de_eventmembersofflink3(inputs)
});
export { eventmembersofflink3 as "eventMembersOffLink" }